module.exports = __webpack_public_path__ + "img/info.86b709bb.png";